import { useMemo, useState } from 'react';
import { ArrowUpRight, Quote } from 'lucide-react';
import SectionHeading from './SectionHeading.jsx';
import { resultFilters, results } from '../data/siteData.js';

export default function Results() {
  const [activeFilter, setActiveFilter] = useState('Összes');

  const visibleResults = useMemo(
    () => (activeFilter === 'Összes' ? results : results.filter((item) => item.category === activeFilter)),
    [activeFilter],
  );

  return (
    <section className="section section--light results-section" id="eredmenyek">
      <div className="container">
        <div className="section-topline section-topline--dark">
          <SectionHeading
            eyebrow="Valódi folyamatok"
            title="Nem ígérek varázslatot. Megmutatom a munkát."
            text="Az alábbi tartalom bemutató adat. Éles indulás előtt kizárólag valós, engedéllyel közzétett kliensfotókra és visszajelzésekre cseréld."
          />
          <div className="section-index">03</div>
        </div>

        <div className="filter-row" role="tablist" aria-label="Eredmények szűrése">
          {resultFilters.map((filter) => (
            <button
              key={filter}
              type="button"
              className={activeFilter === filter ? 'active' : ''}
              onClick={() => setActiveFilter(filter)}
              role="tab"
              aria-selected={activeFilter === filter}
            >
              {filter}
            </button>
          ))}
        </div>

        <div className="results-grid">
          {visibleResults.map((result) => (
            <article className="result-card" key={result.name}>
              <div className="result-images">
                <figure>
                  <img src={result.before} alt={`${result.name} kiindulási állapot – bemutató kép`} loading="lazy" />
                  <figcaption>Előtte</figcaption>
                </figure>
                <figure>
                  <img src={result.after} alt={`${result.name} eredménye – bemutató kép`} loading="lazy" />
                  <figcaption>Utána</figcaption>
                </figure>
                <span className="result-duration">{result.duration}</span>
              </div>
              <div className="result-content">
                <div className="result-meta">
                  <span>{result.category}</span>
                  <strong>{result.outcome}</strong>
                </div>
                <div className="result-quote">
                  <Quote size={20} />
                  <p>{result.quote}</p>
                </div>
                <div className="result-person">
                  <strong>{result.name}</strong>
                  <a href="#kapcsolat" aria-label="Hasonló célhoz konzultáció kérése">
                    Hasonló a célom
                    <ArrowUpRight size={17} />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
